import React from "react";
import { Navigate } from "react-router-dom";
import { RouteProps } from "./PrivateRoute";

export const PublicRoute: React.FC<RouteProps> = ({ isAuthenticated, children }) => {
    return !isAuthenticated ? children : <Navigate to="/" />;
};
